__turbopack_context__.v({
  "modalPopup": "modalPopup-module-scss-module__rx6AUW__modalPopup",
  "modalPopupClose": "modalPopup-module-scss-module__rx6AUW__modalPopupClose",
  "modalPopupClosebtn": "modalPopup-module-scss-module__rx6AUW__modalPopupClosebtn",
  "modalPopupContents": "modalPopup-module-scss-module__rx6AUW__modalPopupContents",
  "modalPopupWrapper": "modalPopup-module-scss-module__rx6AUW__modalPopupWrapper",
  "nlModalOpen": "modalPopup-module-scss-module__rx6AUW__nlModalOpen",
});
